export default __webpack_public_path__ + "static/gba_ep3_compressed-4daf0e8d085e2c35cca2eaea9f801ea7.mp4";